import React from 'react';

const Header = () => {
  const logos = [
    { id: 1, src: '/assets/logo1.png', alt: 'Partner 1' },
    { id: 2, src: '/assets/logo2.png', alt: 'Partner 2' },
    { id: 3, src: '/assets/logo3.png', alt: 'Partner 3' },
  ];

  return (
    <header className="fixed top-0 left-0 w-full z-50 px-6 py-4">
      <div className="flex justify-center">
        <div className="flex items-center space-x-8 md:space-x-12">
          {logos.map((logo) => (
            <div 
              key={logo.id} 
              className="bg-white/5 backdrop-blur-sm rounded-lg p-3 hover:bg-white/10 transition-colors"
            >
              <img
                src={logo.src}
                alt={logo.alt}
                className="h-8 w-auto object-contain opacity-80 hover:opacity-100 transition-opacity"
              />
            </div>
          ))}
        </div>
      </div>
    </header>
  );
};

export default Header;